import { ChangeDetectionStrategy, Component, Inject, OnInit, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ButtonComponent, IconComponent } from '@mode/capra';
import { FileUploadComponent } from './file-upload.component';
import { FileUploadEvent } from '@mode/shared/contract-common';
import { FileUploadDialogData, FileUploadDialogResult } from '@mode/shared/contract-common';
import { MdcDialogHeaderComponent } from '../dialog/mdc-header/mdc-dialog-header.component';

@Component({
  standalone: true,
  selector: 'mode-file-upload-dialog',
  templateUrl: './file-upload-dialog.component.html',
  styleUrls: ['./file-upload-dialog.component.scss'],
  imports: [CommonModule, ButtonComponent, FileUploadComponent, MdcDialogHeaderComponent, IconComponent],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class FileUploadDialogComponent implements OnInit {
  uploading = false;
  @Output() uploadClicked = new EventEmitter<File[]>();
  public selectedFiles: File[] = [];
  public error: string | null = null;
  public hasValidationErrors = false;
  public errorStatusCode: number | null = null;

  showError(message: string, statusCode?: number) {
    this.error = message;
    this.errorStatusCode = statusCode || null;
    this.uploading = false;
  }

  constructor(
    public dialogRef: MatDialogRef<FileUploadDialogComponent, FileUploadDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: FileUploadDialogData
  ) {}

  ngOnInit(): void {
    this.selectedFiles = [];
  }

  public get hasFiles(): boolean {
    return this.selectedFiles.length > 0;
  }

  public get is4xxError(): boolean {
    return this.errorStatusCode !== null && this.errorStatusCode >= 400 && this.errorStatusCode < 500;
  }

  public onFilesSelected(event: any): void {
    if (event.files && event.files.length > 0) {
      this.error = null;
      this.hasValidationErrors = false;
      this.errorStatusCode = null;
    }
    this.selectedFiles = event.files ? event.files.map((uf: any) => uf.file) : event;
  }

  public onFileRemoved(event: FileUploadEvent): void {
    this.error = null;
    this.hasValidationErrors = false;
    this.selectedFiles = event.files.map((uploadedFile) => uploadedFile.file);
  }

  public onUpload(): void {
    this.error = null;
    if (!this.hasFiles) {
      return;
    }
    this.uploading = true;
    this.uploadClicked.emit([...this.selectedFiles]);
  }

  public onCancel(): void {
    this.dialogRef.close();
  }

  /**
   * Handles ESC key and backdrop clicks
   */
  public onNoClick(): void {
    this.onCancel();
  }

  startUploading() {
    this.uploading = true;
  }

  stopUploading() {
    this.uploading = false;
  }

  onUploadError(event: any): void {
    this.error = event[0];
    this.hasValidationErrors = event && event.length > 0;
  }
}
